import { hydrateRoot } from "react-dom/client";
import { App } from "../app";
import type { AppProps, AppSettings } from "../types";
import { parseInitialProps } from "@amzn/exs-gem-react/client";
import React from "react";

/**
 * Shared hydration logic that works for both main document and shadow DOM
 */
export async function hydrateApp(
  container: Document | ShadowRoot,
  rootSelector: string = "#root",
  webComponentSettings?: AppSettings,
) {
  const root = container.querySelector(rootSelector);

  if (!root) {
    return null;
  }

  const initialProps = parseInitialProps<AppProps>(container);

  if (!initialProps) {
    return null;
  }

  const mergedProps = webComponentSettings
    ? {
        ...initialProps,
        settings: { ...initialProps.settings, ...webComponentSettings },
      }
    : initialProps;

  hydrateRoot(root, React.createElement(App, mergedProps));

  return { root, initialProps: mergedProps };
}
